import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { quizJoin } from "./quizApiService";
import { saveStudentSession } from "./quizSession";

export default function QuizStudentJoin() {
  const { t } = useTranslation();
  const { sessionId } = useParams(); // shortId / join code
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [joining, setJoining] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (joining) return;
    const trimmed = name.trim();
    if (!trimmed) {
      setError(t("quiz.nameRequired"));
      return;
    }
    if (trimmed.length < 2) {
      setError(t("quiz.nameMinLength"));
      return;
    }
    setError("");
    setJoining(true);

    try {
      const { uuidParticipant } = await quizJoin({ quizShortId: sessionId, name: trimmed });
      if (!uuidParticipant) {
        throw new Error("Join returned an unexpected response");
      }
      saveStudentSession({ shortId: sessionId, uuidParticipant, name: trimmed });
      navigate(`/quiz/session/${sessionId}/play?name=${encodeURIComponent(trimmed)}`);
    } catch (err) {
      console.error("Failed to join quiz:", err);
      setError(
        err?.response?.data?.data?.error ||
          err?.message ||
          (t("quiz.joinFailed") || "Could not join the quiz. Check the code and try again.")
      );
      setJoining(false);
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-5 max-w-[1500px] mx-auto w-full">
      <div className="w-full max-w-md">
        <img
          src="/assets/images/LOGO.png"
          alt="Zubrus"
          className="mx-auto mb-10 h-12 object-contain"
        />

        <div className="bg-white rounded-[32px] p-8 shadow-sm border border-blue-100 text-center">
          <img src="/assets/images/LOGO.png" alt="Zubrus" className="h-10 mb-4 mx-auto" />
          <h1 className="text-2xl font-bold text-darkblue mb-2">{t("quiz.joinQuiz")}</h1>
          <p className="text-lightgray mb-8">Enter your name to get started</p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (error) setError("");
                }}
                placeholder={t("quiz.yourName")}
                autoFocus
                autoComplete="off"
                className="w-full h-[64px] bg-gray-50 border-2 border-gray-100 rounded-[20px] px-6 text-lg font-medium text-center focus:border-blue-400 focus:bg-white outline-none transition-all placeholder:text-gray-400 text-black"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2 font-medium">{error}</p>
              )}
            </div>

            <button
              type="submit"
              disabled={joining}
              className={`primary-btn w-full !rounded-full h-12 !py-0 flex items-center justify-center text-base font-semibold mt-2 ${
                joining ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {joining ? (t("quiz.joining") || "Joining...") : t("quiz.join")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
